export enum IDCheckMode {
  IDCard = 'id-card',
  Passport = 'passport',
}
